import { useI18n } from "../../../i18n";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";
import { useCustomer, useDelivery, useOrders, usePromotions, useShop } from "../hooks";
import { DeliveryCard, LastOrderCard } from "../home/HomeCards";
import { ListsCard } from "../home/ListsCard";
import { PromoBanner } from "../home/PromoBanner";
import { PreseasonCard } from "../home/PreseasonCard";
import { HomeOffers, HomePosts } from "../home/HomePosts";
import { SkeletonBlock } from "../../../components/common/EmptyState";

export default function Home() {
  const { t } = useI18n();
  const { user } = useAuth();
  const customer = useCustomer(user.customer_code);
  const delivery = useDelivery();
  const orders = useOrders();
  const promos = usePromotions();
  const shop = useShop();
  const c = customer.data;

  return (
    <div className="space-y-6" data-testid="customer-home">
      <Link to="/app/assistant" className="flex items-center gap-3 rounded-2xl bg-navy p-4 text-white shadow-sm transition-transform active:scale-[0.99]" data-testid="home-assistant-card">
        <Sparkles className="h-6 w-6 shrink-0 text-brand" />
        <span className="min-w-0 flex-1"><span className="block font-semibold">{t("ai.homeCard")}</span><span className="block text-xs text-white/70">{t("ai.homeCardSub")}</span></span>
      </Link>
      <div>
        <p className="text-sm text-slate-500">{t("home.hello", { name: user.name })}</p>
        {customer.isLoading ? <SkeletonBlock className="mt-2 h-9 w-64" /> : (
          <>
            <h1 className="mt-1 text-3xl font-bold leading-tight text-navy sm:text-4xl" data-testid="customer-legal-name">{c?.legal_name || c?.name}</h1>
            {c?.legal_name && <p className="mt-1 text-base font-medium text-slate-600 md:text-lg" data-testid="customer-name">{c.name}</p>}
          </>
        )}
      </div>
      <PromoBanner promos={promos.data} />
      <HomePosts />
      <PreseasonCard shop={shop} enabled={user.permissions.includes("orders:write")} />
      <div className="grid gap-3 md:grid-cols-2">
        <DeliveryCard delivery={delivery} />
        <LastOrderCard orders={orders} shop={shop} />
      </div>
      <HomeOffers promos={promos.data} />
      <ListsCard shop={shop} />
    </div>
  );
}
